import * as Member from '../constants'

export const ADD_MEMBER_DETAIL_ATTRIBUTE = 'ADD_MEMBER_DETAIL_ATTRIBUTE'
export const CLICK_MEMBER_DETAIL_ATTRIBUTE = 'CLICK_MEMBER_DETAIL_ATTRIBUTE'
export const EDIT_MEMBER_DETAIL_ATTRIBUTE = 'EDIT_MEMBER_DETAIL_ATTRIBUTE'
export const SERVER_RESOURCE = Member.SERVER_RESOURCE
export const FORM_MEMBER_DETAILS_CANCEL = 'FORM/MEMBER_DETAILS_CANCEL'



// WEBPACK FOOTER //
// ./src/pages/member-details/attributes/constants.ts